import { render, staticRenderFns } from "./refundList.vue?vue&type=template&id=d2bbe09a&scoped=true"
import script from "./refundList.vue?vue&type=script&lang=js"
export * from "./refundList.vue?vue&type=script&lang=js"
import style0 from "./refundList.vue?vue&type=style&index=0&id=d2bbe09a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bbe09a",
  null
  
)

export default component.exports